<template>
  <b-row>
    <b-col cols="12">
      <div class="d-flex align-items-center">
        <b-button to="/settings" variant="outline" class="text-primary">
          <feather-icon icon="ArrowLeftIcon" /> Back to Settings
        </b-button>
        <div>
          <h3 class="font-weight-bolder mb-0">Notification Settings</h3>
          <p class="text-muted mb-0">
            Manage email templates, SMS settings, and notification rules
          </p>
        </div>
      </div>
    </b-col>
    <b-col cols="12" class="mt-2">
      <b-row>
        <b-col cols="6" md="3">
          <b-card border-variant="secondary">
            <div class="d-flex align-items-center" style="gap: 12px">
              <div
                class="rounded-pill d-flex align-items-center justify-content-center"
                style="width: 36px; height: 36px; background: #dbeafe"
              >
                <feather-icon icon="MailIcon" style="color: #155dfc" />
              </div>
              <div>
                <span class="text-muted">Email Templates</span>
                <h4 class="font-weight-bolder mb-0">6</h4>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="6" md="3">
          <b-card border-variant="secondary">
            <div class="d-flex align-items-center" style="gap: 12px">
              <div
                class="rounded-pill d-flex align-items-center justify-content-center"
                style="width: 36px; height: 36px; background: #dcfce7"
              >
                <feather-icon icon="MessageSquareIcon" style="color: #00a63e" />
              </div>
              <div>
                <span class="text-muted">SMS Sent Today</span>
                <h4 class="font-weight-bolder mb-0">1,247</h4>
              </div>
            </div>
          </b-card>
        </b-col>

        <b-col cols="6" md="3">
          <b-card border-variant="secondary">
            <div class="d-flex align-items-center" style="gap: 12px">
              <div
                class="rounded-pill d-flex align-items-center justify-content-center"
                style="width: 36px; height: 36px; background: #ffedd4"
              >
                <feather-icon icon="BellIcon" style="color: #f54a00" />
              </div>
              <div>
                <span class="text-muted">Active Rules</span>
                <h4 class="font-weight-bolder mb-0">4</h4>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="6" md="3">
          <b-card border-variant="secondary">
            <div class="d-flex align-items-center" style="gap: 12px">
              <div
                class="rounded-pill d-flex align-items-center justify-content-center"
                style="width: 36px; height: 36px; background: #f3e8ff"
              >
                <feather-icon icon="SendIcon" style="color: #9810fa" />
              </div>
              <div>
                <span class="text-muted">Emails Sent Today </span>
                <h4 class="font-weight-bolder mb-0">3,892</h4>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12">
      <b-tabs pills active-nav-item-class="active">
        <b-tab title="Email Templates" active>
          <template #title>
            <feather-icon icon="MailIcon" /> <strong>Email Templates </strong>
          </template>
          <EmailTemplates />
        </b-tab>
        <b-tab title="SMS Settings">
          <template #title>
            <feather-icon icon="MessageSquareIcon" />
            <strong>SMS Settings</strong>
          </template>
          <SMSSettings />
        </b-tab>
        <b-tab title="Notification Rules">
          <template #title>
            <feather-icon icon="BellIcon" /> <strong>Notification Rules</strong>
          </template>
          <NotifyRules />
        </b-tab>
        <b-tab title="General Settings">
          <template #title>
            <feather-icon icon="SettingsIcon" />
            <strong>General Settings</strong>
          </template>
          <GeneralSettings />
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BFormCheckbox,
  BTab,
  BTabs,
} from "bootstrap-vue";
import EmailTemplates from "./EmailTemplates.vue";
import NotifyRules from "./NotifyRules.vue";
import SMSSettings from "./SMSSettings.vue";
import GeneralSettings from "./GeneralSettings.vue";

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BFormCheckbox,
    BTab,
    BTabs,
    EmailTemplates,
    NotifyRules,
    SMSSettings,
    GeneralSettings,
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.nav-pills {
  border-bottom: 1px solid #e5e7eb;
  background: #ececf0;
  border-radius: 12px;
  padding: 5px;
  width: 100%;
  .nav-item {
    flex-grow: 1;
  }
}
.nav-pills .nav-link {
  border-radius: 12px;
  color: black;
  background: transparent;
  padding: 8px;
  transition: all 0.2s ease;
  border: none;
}
.nav-pills .nav-link.active {
  background: white !important;
  color: black !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
</style>
